import { render, staticRenderFns } from "./ServicesAgreement.vue?vue&type=template&id=c1b0e926&scoped=true"
import script from "./ServicesAgreement.vue?vue&type=script&lang=js"
export * from "./ServicesAgreement.vue?vue&type=script&lang=js"
import style0 from "./ServicesAgreement.vue?vue&type=style&index=0&id=c1b0e926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b0e926",
  null
  
)

export default component.exports